import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { CTAButton } from './CTAButton';
const items = [{
  name: '"Is This God Or My Fear?" Main Digital Guide',
  value: '$27',
  isBonus: false
}, {
  name: '2-Minute Decision Scorecard',
  value: '$15',
  isBonus: true
}, {
  name: '7 Word-for-Word Scripts for Hard Conversations',
  value: '$19',
  isBonus: true
}, {
  name: '7-Day Discernment Reset Guide',
  value: '$17',
  isBonus: true
}];
export function ValueStackSection() {
  return <section className="py-24 md:py-32 px-4 bg-navy watermark-bg" data-id="element-194">
      <div className="max-w-6xl mx-auto" data-id="element-195">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-20" data-id="element-196">
          <span className="inline-block text-gold font-semibold text-xs tracking-[0.2em] uppercase mb-4" data-id="element-197">
            The Complete Toolkit
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-cream" data-id="element-198">
            Everything You Get Today
            <br className="hidden md:block" data-id="element-199" /> For Only{' '}
            <span className="text-gold" data-id="element-200">$17.95</span>
          </h2>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-201">
          {/* Left: Explosion Mockup */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="relative flex justify-center" data-id="element-202">
            <div className="relative" data-id="element-203">
              <div className="absolute -inset-8 bg-gold/5 rounded-full blur-3xl" data-id="element-204"></div>
              <img src="https://cdn.magicpatterns.com/uploads/1kEXWq4wqYzNydHPTrPHPp/VALUE_STACK_-C.jpg" alt="The complete Is This God or My Fear toolkit — ebook, scorecard, scripts, and reset guide" className="relative w-full max-w-lg rounded-2xl" data-id="element-205" />
            </div>
          </motion.div>

          {/* Right: Value List + Pricing */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-206">
            <div className="space-y-4 mb-10" data-id="element-207">
              {items.map((item, i) => <div key={i} className="flex items-start gap-4 p-5 bg-white/[0.04] rounded-xl border border-white/[0.06]" data-id="element-208">
                  <CheckCircle2 className="w-6 h-6 text-gold flex-shrink-0 mt-0.5" data-id="element-209" />
                  <div className="flex-1" data-id="element-210">
                    {item.isBonus && <span className="text-gold text-xs font-bold tracking-wider uppercase" data-id="element-211">
                        BONUS:{' '}
                      </span>}
                    <span className="text-cream font-medium" data-id="element-212">{item.name}</span>
                  </div>
                  <span className="text-cream/30 font-medium text-sm line-through flex-shrink-0" data-id="element-213">
                    {item.value}
                  </span>
                </div>)}
            </div>

            {/* Pricing Block */}
            <div className="bg-white/[0.04] p-8 rounded-2xl border border-gold/20 mb-8" data-id="element-214">
              <div className="flex justify-between items-center mb-4 pb-4 border-b border-white/[0.06]" data-id="element-215">
                <span className="text-cream/50 font-medium" data-id="element-216">Total Value</span>
                <span className="text-cream/30 font-bold line-through text-xl" data-id="element-217">
                  $78
                </span>
              </div>
              <div className="flex justify-between items-center" data-id="element-218">
                <span className="text-cream font-bold text-xl" data-id="element-219">
                  Your Price Today
                </span>
                <span className="text-gold font-bold text-5xl" data-id="element-220">$17.95</span>
              </div>
            </div>

            <div id="pricing" data-id="element-221">
              <CTAButton mainText="CLAIM MY COMPLETE TOOLKIT — $17.95" large isCheckout data-id="element-222" />
            </div>
          </motion.div>
        </div>

        {/* Lifestyle & Toolkit Images */}
        <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mt-20" data-id="element-223">
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0
        }} className="md:col-span-3 overflow-hidden rounded-2xl border border-white/[0.06]" data-id="element-224">
            <img src="https://cdn.magicpatterns.com/uploads/uH23y21wrSYyTsyoqhEhfT/The_7-Day_Discernment_Reset_-C.jpg" alt="Woman finding clarity with the Is This God or My Fear toolkit" className="w-full h-56 md:h-72 object-cover" data-id="element-225" />
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="md:col-span-2 overflow-hidden rounded-2xl border border-white/[0.06] bg-navy-light flex items-center justify-center p-6" data-id="element-226">
            <div className="text-center" data-id="element-227">
              <span className="text-gold text-xs font-bold tracking-[0.2em] uppercase block mb-3" data-id="element-228">
                Instant Digital Access
              </span>
              <p className="text-cream/80 text-sm leading-relaxed mb-4" data-id="element-229">
                Download the complete toolkit immediately after purchase. Read
                on any device — phone, tablet, or desktop.
              </p>
              <div className="flex items-center justify-center gap-4 text-cream/40 text-xs" data-id="element-230">
                <span data-id="element-231">📱 Phone</span>
                <span data-id="element-232">📖 Tablet</span>
                <span data-id="element-233">💻 Desktop</span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}